import { Component, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { LoaderService } from '~services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {
  @Input()
  public readonly inline = false;

  @Input()
  public readonly message =
    'We are currently processing your request. This may take up to 2 minutes.' +
    '<br>Please do not close your browser';

  public readonly serviceMessage$ = this.loaderService.message$.pipe(
    map((message) => message || this.message),
  );

  constructor(public readonly loaderService: LoaderService) {}
}
